import { useQuery } from "@tanstack/react-query";
import { DeliverableConfiguratorService } from "../services/deliverable.configurator.service";
import { DELIVERABLE_CONFIGURATOR_QUERY_KEY } from "../constants";

export default function useGetDeliverableConfigurators() {
  const {
    data: deliverableConfiguratorsData,
    isFetching: isDeliverableConfiguratorsFetching,
    error: deliverableConfiguratorsError,
    isSuccess: isDeliverableConfiguratorsSuccess,
  } = useQuery({
    queryKey: [...DELIVERABLE_CONFIGURATOR_QUERY_KEY],
    queryFn: () => DeliverableConfiguratorService.getDeliverables(),
  });

  return {
    deliverableConfiguratorsData,
    isDeliverableConfiguratorsFetching,
    deliverableConfiguratorsError,
    isDeliverableConfiguratorsSuccess,
  };
}
